<div class="modal-body lecture-rate text-center">
    <button type="button" class="close" aria-label="Close" (click)="activeModal.close(false)">
        <i class="fa fa-times" aria-hidden="true"></i>
    </button>
    <h3>{{ 'webinar.Webinar_starting_now'|translate}}</h3>
    <p>{{ 'webinar.Ask_questions'|translate }}</p>
    <button class="btn btn-full button-orange" (click)="activeModal.close(true)">{{ 'webinar.See_in_live' }}</button>
</div>
